import { PlanActionTypes } from "../models/planActions";
import { REMOVE_AUDIO } from "../types";

export default (): PlanActionTypes => ({
    type: REMOVE_AUDIO,
});
